import dio, { DioTypes } from 'utils/dio';
import { USE_ACCOUNTING_FLOW } from 'constants/featureToggle';

export default {
  onPageView: (pathname, search, hash) => {
    const isAccountingFT = window.featureToggle?.isEnabled(USE_ACCOUNTING_FLOW);

    const accountingEventName =
      search.includes('tab=1099') || !isAccountingFT
        ? '1099Documents_pageview'
        : 'statements_pageview';

    switch (pathname.toLowerCase()) {
      case '/dashboard':
        return dio?.track('dashboard_pageview', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/my-properties':
        return dio?.track('my_properties_pageview', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/analytics':
        return dio?.track('reports_pageview', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/accounting':
        return dio?.track(accountingEventName, DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/reservation-report':
        return dio?.track('guest_reports_pageview', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/documents':
        return dio?.track('documents_page', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/help-center':
        return dio?.track('help_center_page', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      case '/my-profile':
        return dio?.track('my_profile_page', DioTypes.PAGEVIEW, {
          pathname,
          search,
          hash,
        });
      default:
        break;
    }
  },
};
